document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.js-best-sellers-section');
    if (!section) return;

    const tabs = section.querySelectorAll('.js-tab-btn');
    const contents = section.querySelectorAll('.js-tab-content');
    const viewAllBtn = section.querySelector('.js-view-all-top');
    const grids = section.querySelectorAll('.best-sellers-tabs__grid');

    const flickityInstances = new Map();

    function setEqualHeights(grid) {
        const items = grid.querySelectorAll('.best-sellers-tabs__item');
        // Reset height to measure natural height
        items.forEach(item => {
            item.style.height = 'auto';
        });

        let maxHeight = 0;
        // Small delay if images are still painting, but DOM is loaded
        items.forEach(item => {
            if (item.offsetHeight > maxHeight) {
                maxHeight = item.offsetHeight;
            }
        });

        if (maxHeight > 0) {
            items.forEach(item => {
                item.style.height = maxHeight + 'px';
            });
        }
    }

    function initOrDestroyFlickity() {
        if (typeof Flickity !== 'undefined') {
            const isMobile = window.innerWidth <= 768;

            contents.forEach(content => {
                const grid = content.querySelector('.best-sellers-tabs__grid');
                if (!grid) return;

                // Enforce equal heights BEFORE flickity relies on it
                setEqualHeights(grid);

                const isActive = content.classList.contains('is-active');

                if (isMobile) {
                    if (!flickityInstances.has(grid)) {
                        const mobileColumns = section.dataset.columnsMobile || '1';
                        const autoPlayMode = section.dataset.autoplay === 'true';
                        const autoPlaySpeed = parseInt(section.dataset.autoplaySpeed) || 5000;

                        const flkty = new Flickity(grid, {
                            cellAlign: mobileColumns === '1.5' ? 'left' : 'center',
                            contain: true,
                            wrapAround: true,
                            pageDots: true,
                            prevNextButtons: false,
                            groupCells: false,
                            autoPlay: autoPlayMode ? autoPlaySpeed : false,
                            on: {
                                ready: function () {
                                    setEqualHeights(grid);
                                }
                            }
                        });
                        flickityInstances.set(grid, flkty);
                    } else if (isActive) {
                        setEqualHeights(grid);
                        flickityInstances.get(grid).resize();
                    }
                } else {
                    if (flickityInstances.has(grid)) {
                        flickityInstances.get(grid).destroy();
                        flickityInstances.delete(grid);
                    }
                }
            });
        }
    }

    // Init on load
    // Need a tiny timeout to ensure images or nested components have computed layout bounds
    setTimeout(initOrDestroyFlickity, 50);

    // Re-eval on resize
    window.addEventListener('resize', () => {
        initOrDestroyFlickity();
    });

    const primaryBtn = section.querySelector('.js-btn-primary');

    function updateActionButtons(url) {
        if (viewAllBtn) viewAllBtn.href = url;
        if (primaryBtn) primaryBtn.href = url;
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = tab.dataset.target;
            const collectionUrl = tab.dataset.url;

            // Update active states
            tabs.forEach(t => t.classList.remove('is-active'));
            contents.forEach(c => c.classList.remove('is-active'));

            tab.classList.add('is-active');
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.classList.add('is-active');
                // Resize flickity if mobile
                const grid = targetContent.querySelector('.best-sellers-tabs__grid');
                if (grid && flickityInstances.has(grid)) {
                    flickityInstances.get(grid).resize();
                }
            }

            // Update button links
            if (collectionUrl) {
                updateActionButtons(collectionUrl);
            }
        });
    });
});
